import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ISendToEisExecutorProps } from './ISendToEisExecutorProps';
import { SendToEisExecutorModal } from './SendToEisExecutorModal';

export const SendToEisExecutor = createDocModalExecutor<ISendToEisExecutorProps>({
    modal: SendToEisExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        message: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
